import React from 'react';
import {
	getNonPromoPriceForTier,
	getTitleForTier,
	getPromoPriceForTier,
	isSavodTier,
	getTierPrice,
} from '../../../../helpers/tiers';
import {
	MONTH,
	ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PERIOD_LONG,
	ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO,
	ONBOARDING_TIER_OPTIONS_ADVETISEMENT,
	BLACK_FRIDAY,
} from '../../../../constants/Copy';
import PropTypes from 'prop-types';
import { listenForSpacebar } from '../../../../../common/helpers/accessibility';
import Button from '../../../common/buttons/onboarding/OnboardingButton';
import { TIER_FEATURE_IDS, TIER_IDS } from '../../../../constants/Tiers';
import { matchPath, useLocation } from 'react-router';
import { ROUTE_EMAIL_VERIFIED, ROUTE_TIER_OPTIONS } from '../../../../constants/Routes';
import { getProceedText, renderTierFeature } from '../onboardingHelpers';
import cx from 'classnames';
import { initiateTrackStructEvent } from '../../../analytics/Snowplow';
import {
	EVT_SUBSCRIPTION_CATEGORY,
	EVT_SUBSCRIPTION_HIGHLIGHT,
	EVT_SUBSCRIPTION_SELECT,
	EVT_ELEMENT_INTERACTION,
	EVT_TIER_TABLE,
	EVT_ELEMENT_TYPE_BUTTON,
	EVT_TIER_TABLE_BUTTON,
	EVT_ELEMENT_STYLE_PRIMARY,
	EVT_SELECT,
	EVT_TIER_TITLE,
} from '../../../../constants/SnowplowEvents';
import { TierFeatures } from '../../../../constants/TierFeatures';
import { formatPrice } from '../../../../helpers/number';
import { useSelector } from 'react-redux';
import { getTrialPeriodText } from '../../../../helpers/sitespect';

const Tier = ({
	tierItem,
	selected,
	onClick,
	isPromo,
	isPromoAllowed,
	onButtonClick,
	isBlackFriday,
	isSavodExperiment,
}) => {
	const savodTierCollection = useSelector((state) => state.tiers.savodCollection || []);
	const testingId = `tier-${tierItem.id.toLowerCase()}`;
	const tierPrice = isPromo ? getPromoPriceForTier(tierItem) : getNonPromoPriceForTier(tierItem);
	let { title } = getTitleForTier(tierItem);
	const location = useLocation();
	const isOnPromoRoute = !!matchPath(location.pathname, {
		path: [ROUTE_TIER_OPTIONS, ROUTE_EMAIL_VERIFIED],
		exact: true,
	});
	const isBlackFridayTierBasis = isBlackFriday && tierItem.id === TIER_IDS.ESSENTIAL;
	const isBlackFridayTierPlus = isBlackFriday && tierItem.id === TIER_IDS.STANDARD;
	const isBlackFridayTier = isBlackFridayTierBasis || isBlackFridayTierPlus;
	const proceedText = getProceedText({
		isPromo,
		title,
	});

	const displaySavod = isSavodExperiment && isSavodTier(tierItem.id);

	const savodTier =
		displaySavod && savodTierCollection.find(({ id }) => id === `${tierItem.id}_WITH_ADS`);
	const savodTierPrice = savodTier && getTierPrice(isPromo, savodTier);

	function getDiscountTierPrice() {
		if (isBlackFridayTierBasis) return BLACK_FRIDAY.TIER_PRICE_ESSENTIAL;
		if (isBlackFridayTierPlus) return BLACK_FRIDAY.TIER_PRICE_STANDARD;
		return null;
	}

	return (
		<article
			tabIndex={0}
			className={cx('tierB tierB--withTvg', {
				['tierB--selected']: selected,
				['tier--black-friday']: isBlackFriday,
				['tierB-savod']: isSavodExperiment,
			})}
			data-test={`${testingId}-article`}
			aria-label={`tier-option-${testingId}`}
			onClick={() => {
				if (onClick) {
					initiateTrackStructEvent({
						category: EVT_SUBSCRIPTION_CATEGORY,
						action: EVT_SUBSCRIPTION_HIGHLIGHT,
						label: title,

						rtlElementContext: {
							elementInteraction: EVT_SELECT,
							elementGroup: EVT_TIER_TABLE,
							elementType: EVT_ELEMENT_TYPE_BUTTON,
							elementName: EVT_TIER_TITLE,
							elementLabel: proceedText,
						},
					});
					onClick(tierItem);
				}
			}}
			onFocus={() => window.addEventListener('keyup', listenForSpacebar)}
			onBlur={() => window.removeEventListener('keyup', listenForSpacebar)}
		>
			{isBlackFridayTier && (
				<>
					<div
						className={cx('tier__label', {
							['tier__label--selected']: selected,
						})}
					>
						{BLACK_FRIDAY.TIER_LABEL}
					</div>
				</>
			)}
			<header
				className={cx('tierB__header', {
					['tierB__header-savod']: isSavodExperiment,
				})}
			>
				<h2 data-test={`${testingId}-title`} className="tierB__name">
					{title}
				</h2>
				{isSavodExperiment ? (
					displaySavod ? (
						<>
							<div className="tierB__header-savod__price">
								<span className="tierB__header-savod__price__advertisement">Zonder reclame</span>
								<RenderTierPrice
									testingId={testingId}
									tierPrice={tierPrice}
									isDiscount={isBlackFridayTier}
									discountPrice={getDiscountTierPrice}
									discountPeriod={isBlackFridayTier ? BLACK_FRIDAY.TIER_PERIOD : null}
									selected={selected}
									isSavodExperiment={isSavodExperiment}
								/>
							</div>
							<div className="tierB__header-savod__price__discount">
								<span className="tierB__header-savod__price__discount-container">
									of<span className="tierB__header-savod__price__advertisement"> Met reclame</span>
								</span>
								<RenderTierPrice
									testingId={testingId}
									tierPrice={savodTierPrice}
									isDiscount={isBlackFridayTier}
									discountPrice={getDiscountTierPrice}
									discountPeriod={isBlackFridayTier ? BLACK_FRIDAY.TIER_PERIOD : null}
									selected={selected}
									isSavodExperiment={isSavodExperiment}
								/>
							</div>
						</>
					) : (
						<div className="tierB__header-savod__price tierB__header-savod-normal-tier">
							{TierFeatures[TIER_FEATURE_IDS.AD_FREE].values[tierItem.id] ? null : (
								<div className="tierB__header-savod__price__advertisement">
									{ONBOARDING_TIER_OPTIONS_ADVETISEMENT}
								</div>
							)}
							<RenderTierPrice
								testingId={testingId}
								tierPrice={tierPrice}
								isDiscount={isBlackFridayTier}
								discountPrice={getDiscountTierPrice}
								discountPeriod={isBlackFridayTier ? BLACK_FRIDAY.TIER_PERIOD : null}
								selected={selected}
								isSavodExperiment={isSavodExperiment}
							/>
						</div>
					)
				) : (
					<>
						{TierFeatures[TIER_FEATURE_IDS.AD_FREE].values[tierItem.id] ? null : (
							<div className="tierB__advertisement">{ONBOARDING_TIER_OPTIONS_ADVETISEMENT}</div>
						)}
						<RenderTierPrice
							testingId={testingId}
							tierPrice={tierPrice}
							isDiscount={isBlackFridayTier}
							discountPrice={getDiscountTierPrice}
							discountPeriod={isBlackFridayTier ? BLACK_FRIDAY.TIER_PERIOD : null}
							selected={selected}
						/>
					</>
				)}
				{isOnPromoRoute && isPromoAllowed && tierItem.id !== TIER_IDS.FREE && !isSavodExperiment ? (
					<div className={cx('tierB__promo-period')}>
						{getTrialPeriodText(ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PERIOD_LONG)}
					</div>
				) : null}
				{displaySavod ? (
					<div className="tierB__promo-period tierB__promo-period-selected">
						Of <span>met reclame</span> &euro;{formatPrice(savodTierPrice)}
					</div>
				) : null}
			</header>
			<div className="tierB-features">
				{Object.keys(TIER_FEATURE_IDS).map((tierFeatureId) =>
					renderTierFeature({
						featureId: tierFeatureId,
						tierId: tierItem.id,
						showTiers: true,
						isSavodExperiment: isSavodExperiment,
					})
				)}
			</div>
			<Button
				testId="tiersB-button"
				className={cx('onboarding-button--tier-button', {
					['onboarding-button--tier-button--disabled']: !selected,
				})}
				onClick={async (e) => {
					e.stopPropagation();
					await initiateTrackStructEvent({
						category: EVT_SUBSCRIPTION_CATEGORY,
						action: EVT_SUBSCRIPTION_SELECT,
						label: proceedText,

						rtlElementContext: {
							elementInteraction: EVT_ELEMENT_INTERACTION,
							elementGroup: EVT_TIER_TABLE,
							elementType: EVT_ELEMENT_TYPE_BUTTON,
							elementName: EVT_TIER_TABLE_BUTTON,
							elementLabel: proceedText,
							elementStyle: EVT_ELEMENT_STYLE_PRIMARY,
						},
					});
					onButtonClick(tierItem);
				}}
			>
				{isSavodExperiment ? 'Ga verder ' : proceedText}
			</Button>
		</article>
	);
};

const RenderTierPrice = ({
	testingId,
	tierPrice,
	isDiscount,
	discountPrice,
	discountPeriod,
	selected,
	isSavodExperiment,
}) => (
	<p className="tierB__price-period">
		{discountPeriod && (
			<span
				className={cx('tier__period-info', {
					['tier__period-info--selected']: selected,
				})}
			>
				{discountPeriod}
			</span>
		)}
		{!isSavodExperiment && <br />}
		{tierPrice > 0 ? (
			<>
				<span data-test={`${testingId}-price`}>
					<span
						className={cx('', {
							['tier__price_discount']: isDiscount,
						})}
					>
						&euro;
						{formatPrice(tierPrice)}
					</span>
				</span>
				{isDiscount ? <span>&euro;{discountPrice()}</span> : null}
				<span className="tierB__period">/ {MONTH}</span>
			</>
		) : (
			ONBOARDING_TIER_OPTIONS_PROMO_PERIOD_PROMO
		)}
	</p>
);

Tier.propTypes = {
	tierItem: PropTypes.object.isRequired,
	selected: PropTypes.bool,
	onClick: PropTypes.func,
	isPromo: PropTypes.bool,
	variantPromoPeriod: PropTypes.string,
};

export default Tier;
